var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup292(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09724 1.75794C0.624939 3.23029 0.624939 5.59992 0.624939 10.3392V60.6071C0.624939 70.0856 0.62494 74.8249 3.56958 77.7696C5.21128 79.4113 7.4108 80.1377 10.6785 80.4594V73.1741C10.6785 69.0099 14.0544 65.6339 18.2187 65.6339C22.383 65.6339 25.7589 69.0099 25.7589 73.1741V80.7143H45.8661V73.1741C45.8661 69.0099 49.242 65.6339 53.4062 65.6339C57.5704 65.6339 60.9464 69.0099 60.9464 73.1741V80.4594C64.2143 80.1377 66.4136 79.4113 68.0553 77.7696C71 74.8249 71 70.0856 71 60.6071V10.3392C71 5.59992 71 3.23029 69.5277 1.75794C68.0553 0.285645 65.6857 0.285645 60.9464 0.285645H10.6785C5.93921 0.285645 3.56958 0.285645 2.09724 1.75794Z",
    fill: "#03468F",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7053 22.9065C15.7053 21.5184 16.8306 20.3931 18.2187 20.3931H53.4062C54.7943 20.3931 55.9196 21.5184 55.9196 22.9065C55.9196 24.2946 54.7943 25.4199 53.4062 25.4199H18.2187C16.8306 25.4199 15.7053 24.2946 15.7053 22.9065Z",
    fill: "#03468F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7053 37.9865C15.7053 36.5984 16.8306 35.4731 18.2187 35.4731H38.3259C39.714 35.4731 40.8393 36.5984 40.8393 37.9865C40.8393 39.3746 39.714 40.4999 38.3259 40.4999H18.2187C16.8306 40.4999 15.7053 39.3746 15.7053 37.9865Z",
    fill: "#03468F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7053 53.0671C15.7053 51.679 16.8306 50.5537 18.2187 50.5537H48.3794C49.7676 50.5537 50.8928 51.679 50.8928 53.0671C50.8928 54.4552 49.7676 55.5805 48.3794 55.5805H18.2187C16.8306 55.5805 15.7053 54.4552 15.7053 53.0671Z",
    fill: "#03468F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9196 73.1745C55.9196 71.7866 54.7941 70.6611 53.4062 70.6611C52.0183 70.6611 50.8928 71.7866 50.8928 73.1745H55.9196ZM50.8928 73.1745V80.7147H55.9196V73.1745H50.8928Z",
    fill: "#03468F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7321 73.1745C20.7321 71.7866 19.6068 70.6611 18.2187 70.6611C16.8306 70.6611 15.7053 71.7866 15.7053 73.1745H20.7321ZM15.7053 73.1745V80.7147H20.7321V73.1745H15.7053Z",
    fill: "#03468F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup292);
export default __webpack_public_path__ + "static/media/Group 29 (2).47e1793dcf2f37a03b0dc7979dcae371.svg";
export { ForwardRef as ReactComponent };